import React, { useState } from "react";
import NoDataFound from "../NoDataFound/NoDataFound";
import "./AddTransactions.css";
import PropertyIcon from "../assets/Icons/property.svg";
import CheckIcon from "../assets/Icons/check.svg";
import DeleteIcon from "../assets/Icons/deleteT.svg";
import TransactionModal from "./Modal/TransactionModal";
import ConfirmationModal from "../../../components/Common/ConfirmationModal/ConfirmationModal";
import { deleteDoc, doc } from "firebase/firestore";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { db } from "../../../firebase";
import getSettings from "../../../controllers/settings/getSettings";
import { useEffect } from "react";
import FormatPriceNumeral from "../../../helpers/FormatPriceNumeral";
import FormatPriceVerbal from "../../../helpers/FormatPriceVerbal";

const AddTransactions = ({
  transactions,
  setTransactions,
  isBtnDisable,
  dealId,
  addOrUpdateTransactions,
  Toggler,
  ToggleComponents,
}) => {
  //this state is used for updating a single transaction
  const [singleTransaction, setSingleTransaction] = useState(null);

  //  CurrencyState start
  const [mCurrencySettings, setMCurrencySettings] = useState({});
  useEffect(() => {
    async function fetchData() {
      const settings = await getSettings();
      setMCurrencySettings(settings);
    }
    fetchData();
  }, []);

  // CurrencyState Ends

  //ui states
  const [modalStatus, setModalStatus] = useState("");
  const [toggleTransactions, setToggleTransactions] = useState(false);
  const [myIndex, setIndex] = useState(-1);
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const handleOpenDeleteDialog = () => {
    setDeleteDialog(true);
  };
  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      let myIndexTempElement = transactions[myIndex];

      transactions.splice(myIndex, 1);
      setTransactions(transactions);
      if (myIndexTempElement.hasOwnProperty("id")) {
        const id = myIndexTempElement.id;
        await deleteDoc(doc(db, "deals", dealId, "transactions", id));
      }
      setDeleteDialog(false);
      setIndex(-1);
    }
  };

  return (
    <>
      <TransactionModal
        {...{
          modalStatus,
          setModalStatus,
          transactions,
          setTransactions,
          singleTransaction,
          setSingleTransaction,
          myIndex,
          addOrUpdateTransactions,
          mCurrencySettings,
          FormatPriceNumeral,
          FormatPriceVerbal,
        }}
      />
      <ConfirmationModal
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this transaction?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
      <div
        className={`transaction-card b  ${
          isBtnDisable === true && "custom-disable-card"
        }  `}
      >
        <div className="transaction-card-content">
          <div
            className="transaction-card-header"
            onClick={() => {
              if (isBtnDisable === false) {
                setModalStatus(true);
              }
            }}
          >
            <p className="transaction-card-title">Add Transactions</p>
            <button type="button">
              <svg
                width={14}
                height={15}
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.71527 9.73424H5.46973M7.0925 8.14844V11.398"
                  stroke="white"
                  strokeMiterlimit={10}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.67661 1.33675L7.65713 1.38224L5.77472 5.75619H3.92476C3.48336 5.75619 3.06144 5.84718 2.67847 6.00966L3.81441 3.293L3.84037 3.22801L3.88581 3.12402C3.89879 3.08503 3.91177 3.04603 3.93125 3.01354C4.78158 1.04428 5.74226 0.595839 7.67661 1.33675V1.33675Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11.175 5.88537C10.8829 5.79438 10.5713 5.75538 10.2598 5.75538H5.77441L7.65683 1.38143L7.6763 1.33594C7.77367 1.36843 7.86455 1.41393 7.96191 1.45292L9.39644 2.05735C10.1948 2.38881 10.7531 2.73326 11.0906 3.14921C11.1555 3.2272 11.2075 3.29869 11.2529 3.38318C11.3113 3.47417 11.3568 3.56516 11.3827 3.66265C11.4087 3.72114 11.4282 3.77963 11.4411 3.83162C11.6164 4.37756 11.5125 5.04697 11.175 5.88537V5.88537Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.4271 8.92941V10.1968C13.4271 10.3267 13.4206 10.4567 13.4141 10.5867C13.2907 12.8549 12.025 13.9988 9.62328 13.9988H4.56023C4.40444 13.9988 4.24865 13.9858 4.09936 13.9663C2.03519 13.8298 0.931708 12.7249 0.795395 10.6582C0.775922 10.5087 0.762939 10.3527 0.762939 10.1968V8.92941C0.762939 7.62308 1.55485 6.49872 2.6843 6.01128C3.07377 5.8488 3.4892 5.75781 3.93059 5.75781H10.2659C10.584 5.75781 10.8955 5.80331 11.1811 5.8878C12.4729 6.28425 13.4271 7.49309 13.4271 8.92941V8.92941Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.81267 3.29688L2.67673 6.01353C2.10689 6.25898 1.62128 6.66611 1.27985 7.18468C0.938413 7.70324 0.756088 8.31056 0.755371 8.93167V7.02741C0.755371 5.18164 2.06657 3.64133 3.81267 3.29688V3.29688ZM13.4253 7.02741V8.93167C13.4253 7.50185 12.4776 6.2865 11.1794 5.89655C11.5169 5.05165 11.6143 4.38874 11.452 3.83631C11.4391 3.77781 11.4196 3.71932 11.3936 3.66733C12.601 4.29125 13.4253 5.57159 13.4253 7.02741Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>

          <div className="transaction-card-body">
            <div className="title-container">
              <div className="left">
                <span className="transaction-title">Transactions</span>
                <span className="tot-transactions">
                  ({transactions.length})
                </span>
              </div>
              <div className="right">
                <div
                  onClick={() => {
                    // setToggleTransactions(!toggleTransactions);
                    Toggler();
                  }}
                  className={`transaction-toggler  ${
                    !ToggleComponents ? "toggle-active" : " "
                  }  `}
                >
                  <svg
                    width={17}
                    height={9}
                    viewBox="0 0 17 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.8"
                      d="M16.2271 8.0975L9.87105 1.5775C9.12041 0.8075 7.89209 0.8075 7.14145 1.5775L0.7854 8.0975"
                      stroke="#545454"
                      strokeWidth="1.5"
                      strokeMiterlimit={10}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            {ToggleComponents && transactions.length > 0 ? (
              <div className="transaction-elements-container">
                {transactions.length > 0 &&
                  transactions.map((t, index) => {
                    return (
                      <div
                        className="transaction-element"
                        onClick={() => {
                          setSingleTransaction(t);
                          setIndex(index);
                          setModalStatus("update");
                        }}
                      >
                        <div className="left">
                          <p>
                            {t.amount &&
                              " " + mCurrencySettings?.currency + " "}
                            {mCurrencySettings.currencyFormat === "numeral"
                              ? FormatPriceNumeral(t.amount)
                              : FormatPriceVerbal(t.amount)}
                          </p>
                          <small>{t.comment}</small>
                        </div>
                        <div className="right">
                          <div className="payment-type-container">
                            <div>
                              <svg
                                width="10"
                                height="9"
                                viewBox="0 0 10 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.44649 0L4.48388 1.47679L4.68281 1.60449L6.42891 0.290583L9.39058 2.2572L7.69181 3.53545L7.77457 3.58855V3.75058L9.10514 2.74933L9.3844 2.93479L7.77455 4.14612V4.4235L9.07908 3.44187L9.3844 3.64465L7.77455 4.85598V5.13336L9.07908 4.15173L9.3844 4.35451L7.77455 5.56584V5.84322L9.79359 4.32394L9.29247 3.99121L9.79357 3.61413L9.29245 3.28135L9.79355 2.90427L9.31848 2.58879L9.7997 2.22666L6.44647 0H6.44649ZM7.07354 1.0586C6.64892 1.30837 6.08333 1.35063 5.6851 1.16231L4.90661 1.74809L7.46799 3.39183L8.20636 2.83626C7.91551 2.5671 7.93973 2.16547 8.26574 1.8503L7.07352 1.0586H7.07354ZM4.43774 1.93274L3.01099 3.02338L5.74811 4.87051L5.77496 4.8504C5.82542 4.8123 5.89667 4.75836 5.98168 4.69393C6.15163 4.56514 6.37654 4.39438 6.6008 4.22402C6.92378 3.97865 7.09021 3.85206 7.24498 3.73437L4.43774 1.93274ZM6.7683 1.96042C6.76832 1.96042 6.76834 1.96042 6.76836 1.96042C6.83291 1.96088 6.8921 1.9771 6.93629 2.00644C6.96202 2.02352 6.98197 2.04458 6.995 2.06843C7.00804 2.09227 7.01392 2.11844 7.01228 2.14542C7.01065 2.17241 7.00155 2.19969 6.9855 2.22571C6.96945 2.25172 6.94676 2.27597 6.91873 2.29705C6.89071 2.31813 6.8579 2.33565 6.82217 2.34859C6.78644 2.36154 6.7485 2.36966 6.7105 2.3725C6.6725 2.37533 6.6352 2.37282 6.60072 2.36511C6.56624 2.35741 6.53526 2.34465 6.50955 2.32757C6.45762 2.29309 6.4303 2.24311 6.43359 2.18862C6.43688 2.13413 6.47052 2.07959 6.52711 2.03701C6.55924 2.01283 6.59762 1.99338 6.63939 1.98012C6.68115 1.96685 6.72522 1.96012 6.7683 1.96042ZM2.3597 3.07522L0.23223 4.67602L0.707296 4.99149L0.226074 5.35362L0.727197 5.68637L0.226074 6.06348L0.727197 6.39623L0.226074 6.77334L3.57931 9L5.60382 7.47655V7.19924L3.59689 8.70939L0.63524 6.74275L0.92296 6.52625L3.57931 8.29012L5.60382 6.76672V6.48941L3.59689 7.99956L0.63524 6.03291L0.92296 5.81641L3.57931 7.58028L5.60382 6.05688V5.77957L3.59689 7.28972L0.63524 5.32308L0.903079 5.12148L3.5855 6.9027L5.60382 5.38393V5.26444L5.49321 5.18982L3.603 6.61209L0.641436 4.64547L2.55405 3.2063L2.35968 3.07515L2.3597 3.07522ZM2.77266 3.35395L1.82564 4.0665C2.11649 4.33563 2.09227 4.73725 1.76626 5.05246L2.95847 5.84417C3.38308 5.59438 3.94863 5.55214 4.34686 5.74044L5.2746 5.04234L2.77262 3.35392L2.77266 3.35395ZM7.41124 4.1156C7.24888 4.23904 7.1057 4.348 6.7984 4.58144C6.59198 4.7383 6.3855 4.89504 6.17896 5.05166C6.09384 5.11614 6.02243 5.1702 5.97151 5.20858C5.96969 5.21 5.96894 5.21047 5.96717 5.21182V7.24488L7.41126 6.10707V4.1156H7.41124ZM3.3545 4.5292C3.41906 4.52967 3.47824 4.54591 3.52243 4.57527C3.57436 4.60975 3.60168 4.65973 3.59839 4.71422C3.59509 4.76871 3.56145 4.82325 3.50487 4.86583C3.44828 4.90839 3.37339 4.93552 3.29667 4.94125C3.21995 4.94697 3.14767 4.93082 3.09574 4.89635C3.04381 4.86187 3.01649 4.81188 3.01979 4.75739C3.02308 4.7029 3.05672 4.64837 3.1133 4.60579C3.14544 4.58161 3.18382 4.56216 3.22559 4.5489C3.26735 4.53564 3.31142 4.52892 3.3545 4.52922V4.5292Z"
                                  fill="#4C3CA6"
                                />
                              </svg>
                            </div>
                            <p>Payment Type</p>
                          </div>
                          <div className="payment-type">
                            <p>{t.paymentType}</p>
                          </div>
                          <div>
                            <img
                              onClick={(e) => {
                                e.stopPropagation();
                                setIndex(index);
                                handleOpenDeleteDialog();
                              }}
                              src={DeleteIcon}
                              alt="img"
                              width={20}
                              height={13}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            ) : (
              ToggleComponents && (
                <div
                  className="add-deal-common-btn"
                  onClick={() => {
                    if (isBtnDisable === false) {
                      setModalStatus(true);
                    }
                  }}
                >
                  <svg
                    width={28}
                    height={27}
                    viewBox="0 0 28 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.6097 13.2033H1M13.8048 1V26.0067"
                      stroke="#767676"
                      strokeMiterlimit={10}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <h3>Add Transactions</h3>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTransactions;
